<template>
  <div class="footer">
    <div class="footer__youtube-suggester">
      <a-button
        type="link"
        href="https://synthetic.ua/pages"
        target="_blank"
      >
        {{ $t("app.knowledge_base") }}
      </a-button>
      <!-- <youtube-suggester :collapsed="!isSidebarOpened" /> -->
    </div>
    <div
      v-if="version"
      class="footer__version"
    >
      {{ version }}
    </div>
  </div>
</template>

<script>
// import YoutubeSuggester from './YoutubeSuggester.vue'

export default {
  name: "DashboardSidebarFooter",
  props: {
    isSidebarOpened: {
      type: Boolean,
      required: true
    }
  },
  components: {
    // YoutubeSuggester
  },
  data() {
    // Версію з тега релізу CI передає лише під час білду з тега
    const tagVersion = process.env.VUE_APP_VERSION
    const version = tagVersion ? `v. ${tagVersion}` : ""

    return {
      version
    }
  }
}
</script>

<style lang="scss" scoped>
$collapse-switcher-height: 48px;
$version-height: 40px;

.footer {
  margin-top: auto;
  display: flex;
  flex-direction: column;

  &__youtube-suggester {
    display: flex;
    justify-content: center;
    cursor: default;
    padding: 0 16px 0 16px;
  }

  &__version {
    display: flex;
    justify-content: center;
    align-items: center;
    height: $version-height;
    color: $font-color-white-lighter;
    cursor: default;
  }
}
</style>
